export default function HeaderSearch() {
	const searchToggle = document.querySelector('.header__search-toggle');
	const body = document.querySelector('body');

	if(searchToggle) {
		searchToggle.addEventListener('click', () => {
			body.classList.toggle('search-active');
			// Add focus to the search input
			document.querySelector('.search-form__field').focus();
		});
	}
}